(function () {
  console.log('cookie script loaded');

  const replaceCookieTitle = () => {
    const title = document.querySelector('#shopify-pc__banner__body-title');

    if (!title) return;

    if (title.tagName !== 'H2') return;

    const replacement = document.createElement('p');

    replacement.id = title.id;
    replacement.className = title.className;
    replacement.innerHTML = title.innerHTML;
    replacement.dataset.replaced = 'true';

    title.replaceWith(replacement);
  };

  replaceCookieTitle();

  const observer = new MutationObserver(replaceCookieTitle);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
